import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILicenca } from 'src/app/shared/api/licencas/licencas.service';
import { PaginatedResponse } from 'src/app/shared/api/pagination.model';
import { TemplateApiService } from 'src/app/shared/api/template-api.service';

@Injectable()
export class LicencasFiltradasService extends TemplateApiService<ILicenca> {
    private licencas: ILicenca[] = [];

    public override setBaseUrl() {
        this.baseUrl = ``;
    }

    public override get(params: {
        pagina: number;
        tamanho: number;
    }): Observable<PaginatedResponse<ILicenca>> {
        return new Observable((observer) => {
            const pagina = params.pagina || 1;
            const tamanho = params.tamanho || 10;

            const inicio = (pagina - 1) * tamanho;
            const fim = inicio + tamanho;

            const resultadosPaginados = this.licencas.slice(inicio, fim);
            const totalPaginas = Math.ceil(this.licencas.length / tamanho);

            const retorno: PaginatedResponse<ILicenca> = {
                'total-paginas': totalPaginas,
                pagina: pagina,
                total: this.licencas.length,
                resultados: resultadosPaginados
            };

            observer.next(retorno);
        });
    }

    public setLicencas(licencas: ILicenca[]) {
        this.licencas = licencas;
    }
}
